import { pushApi } from "@/lib/api";

// Convert a base64url VAPID public key to the Uint8Array applicationServerKey.
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) output[i] = raw.charCodeAt(i);
  return output;
}

export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export function getPermission() {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission; // "granted" | "denied" | "default"
}

async function getRegistration() {
  // sw.js is registered in index.js; wait until it's ready.
  return navigator.serviceWorker.ready;
}

export async function getExistingSubscription() {
  if (!isPushSupported()) return null;
  const reg = await getRegistration();
  return reg.pushManager.getSubscription();
}

export async function enablePush() {
  if (!isPushSupported()) {
    throw new Error("Push wird auf diesem Gerät/Browser nicht unterstützt.");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Benachrichtigungen wurden im Browser blockiert.");
  }

  const reg = await getRegistration();
  const { data } = await pushApi.getVapidKey();
  const applicationServerKey = urlBase64ToUint8Array(data.publicKey);

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey,
    });
  }

  await pushApi.subscribe(sub.toJSON());
  return true;
}

export async function disablePush() {
  const sub = await getExistingSubscription();
  if (sub) {
    try {
      await pushApi.unsubscribe(sub.endpoint);
    } catch (e) {
      console.debug("Push-Abmeldung beim Backend fehlgeschlagen (lokal trotzdem abgemeldet):", e);
    }
    await sub.unsubscribe();
  }
  return true;
}
